import React, { useContext } from "react";
import { useTranslation } from "react-i18next";

import Layout from "layouts/LayoutMasterDetail";
import ServiceItem from "./ShiftPersonelServiceItem";
import ServiceMetricCell from "features/services/shared/ServiceMetricCell";
import { getServiceRouteTimeColumns } from "features/services/shared/serviceRouteTimeColumns";
import { StoreContext } from "shared/context/store-context";
import { vehicleroutetypes_tr, vehicleroutetypes_en } from "shared/util/types";
import CreateShiftRoutesAutomation from "components/shared/automations/CreateShiftRoutesAutomation";
import { noPersonelSchoolBlocker } from "shared/utility/blocker-conditions";
import { days, days_en } from "shared/util/types";
import { getCurrentLanguage } from "shared/utility/lang";

const ShiftPersonelServices = () => {
  const { t } = useTranslation();

  const currentLanguage = getCurrentLanguage();
  const days_to_use = currentLanguage === "tr" ? days : days_en;
  const vehicleroutetypes = currentLanguage === "tr" ? vehicleroutetypes_tr : vehicleroutetypes_en;

  const {
    shiftPersonelServices,

    personelSchoolOptions,
    schools,
    driverOptions,
    shiftOptions,
    DeletePersonelService,
    InsertPersonelService,
    UpdatePersonelService,
  } = useContext(StoreContext);
  const itemType = "shiftpersonelservice";
  const listName = "shiftpersonelservices";

  let listColumns = [];

  if (personelSchoolOptions?.length > 1) {
    listColumns.push({
      field: "school",
      headerName: t("client"),
      width: 250,
      valueGetter: (params) =>
        personelSchoolOptions.find((item) => item?.value?.toString() === params?.row?.school?.id?.toString())?.label,
    });
  }

  listColumns.push({ field: "date", headerName: t("date"), width: 150 });

  // listColumns.push(
  //   {
  //     field: "day",
  //     headerName: t("day"),
  //     width: 200,
  //     valueGetter: (params) => {
  //       return days_to_use?.find((item) => item.value.toString() === params.row.day.toString())?.label || "";
  //     },
  //   }
  // );

  listColumns.push({
    field: "shift",
    headerName: t("shift.title"),
    width: 250,
    valueGetter: (params) => {
      try {
        return shiftOptions.find((item) => item.value.toString() === params.row.shift.toString()).label;
      } catch (e) {
        return "";
      }
    },
  });

  listColumns.push({
    field: "type",
    headerName: t("serviceType"),
    width: 100,
    valueGetter: (params) =>
      vehicleroutetypes.find((item) => item?.value?.toString() === params.row.type.toString())?.label,
  });

  listColumns.push({ field: "name", headerName: t("name"), width: 400 });
  listColumns.push({
    field: "drivers",
    headerName: t("driver"),
    width: 300,
    valueGetter: (params) => {
      try {
        return driverOptions.find((item) => item.value.toString() === params?.row?.drivers[0]?.id.toString()).label;
      } catch (e) {
        return "";
      }
    },
  });

  listColumns.push({ field: "plate", headerName: t("plate"), width: 150 });
  listColumns.push({
    field: "numOfPassengers",
    headerName: t("numberofpassengers"),
    width: 100,
    valueGetter: (params) => params.row?.users?.length?.toString() || "-",
  });

  listColumns.push(...getServiceRouteTimeColumns(t));
  // Rota metriği (mesafe/süre). Eksikse listede kırmızı "Hesaplanmadı" rozeti gösterilir.
  listColumns.push({
    field: "routeMetrics",
    headerName: t("routeMetrics"),
    width: 200,
    valueGetter: (params) => {
      const duration = Number(params.row?.totalDuration);
      return Number.isFinite(duration) ? duration : 0;
    },
    renderCell: (params) => <ServiceMetricCell row={params.row} />,
  });

  return (
    <Layout
      itemType={itemType}
      items={shiftPersonelServices}
      listName={listName}
      listColumns={listColumns}
      SelectedItemComponent={ServiceItem}
      NewItemComponent={ServiceItem}
      DeleteItem={DeletePersonelService}
      InsertItem={InsertPersonelService}
      UpdateItem={UpdatePersonelService}
      isAlwaysFullScreen={true}
      hideCreateNewItemWhenSelected={true}
      BulkProcessComponent={CreateShiftRoutesAutomation}
      blockerConditions={[noPersonelSchoolBlocker(schools)]}
    />
  );
};

export default ShiftPersonelServices;
